import { AccountCreation } from '@/components/signup/account-creation/account-creation';
import { useLoggedIn } from '@/components/user-context/helpers/cohorts';
import { getWacIntegrationUrl } from '@/utils/urls';

import { NoCreditCardRequired } from '../components/no-credit-card-required';
import { SignupDefault } from '../components/signup-default';

import { CreateYourAccount } from './components/create-your-account';
import { DeveloperBundleTemplate } from './components/developer-bundle-template';

export const DeveloperBundleSignup = () => {
	const isLoggedIn = useLoggedIn();

	if (isLoggedIn) {
		return <SignupDefault />;
	}

	return (
		<DeveloperBundleTemplate>
			<CreateYourAccount />
			<AccountCreation
				Login={<NoCreditCardRequired />}
				getContinueUrl={() => `${getWacIntegrationUrl()}/try/cloud/signup?developer=true`}
			/>
		</DeveloperBundleTemplate>
	);
};
